import React from "react";
import PropTypes from "prop-types";
import { ChevronLeft, InfoCircleFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router";
import infoIcon from "../../assets/icons/Information-fill.svg";

const PageLayout = ({
  heading,
  subHeading,
  onBack,
  children,
  actions,
  className,
  infoText,
  isBack = true,
  formError,
  bodyClassName = "",
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={`page-layout ${className || ""}`.trim()}>
      <div className="page-layout__header">
        <div>
          <h1>{heading}</h1>
          {subHeading && <p>{subHeading}</p>}
          {formError && (
            <span className="server-error">
              <InfoCircleFill />
              {formError}
            </span>
          )}
        </div>

        {isBack && (
          <button
            type="button"
            className="page-layout__back"
            onClick={handleBack}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.4696 5.46967L15.5303 6.53033L10.0606 12L15.5303 17.4697L14.4696 18.5303L7.93928 12L14.4696 5.46967Z"
                fill="#05054B"
              />
            </svg>
            Back
          </button>
        )}
      </div>

      {infoText && (
        <div className="page-layout__info-box">
          <img src={infoIcon} alt="" />
          <span>{infoText}</span>
        </div>
      )}

      <div className={`page-layout__body ${bodyClassName}`}>{children}</div>

      {actions && <div className="page-layout__actions">{actions}</div>}
    </div>
  );
};

PageLayout.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onBack: PropTypes.func,
  children: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string,
  infoText: PropTypes.string,
  isBack: PropTypes.bool,
  formError: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default PageLayout;
